import { Status, StatusValue } from "../core/types";

export const ensureStatusValueArr = (srcArray: string[]): StatusValue[] => {
  if (
    srcArray.every<StatusValue>((src): src is StatusValue =>
      Object.values(Status).some((status) => status === src),
    )
  ) {
    return srcArray;
  }
  throw new Error("undefined status");
};
